import { useContext, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../components/common/forms/Title/TitleComponent';
import createIcon from '~/src/static/img/createIcon.svg';
import GridWrapper from '~/src/components/common/GridWrapper';
import RolesDependent from '~/src/components/common/RolesDependent';
import DisplayDate from '~/src/components/common/DisplayDate';
import { API_URL, ROLES } from '~/src/utils/constants';
import { INTEGRATION_STATUS, INTEGRATION_TYPE } from '~/src/utils/integrationsConstants';
import MyContext from '~/src/services/context';
import { grantedForRole } from '~/src/utils/misc';

export default function IntegrationsList(): JSX.Element {
  const stateRef = useRef(null);
  const url = `${API_URL}/integrations/get-all`;
  const history = useHistory();
  const StatefullGrid = withState(Grid, url);

  const context = useContext(MyContext);
  const permissionGranted = grantedForRole([ROLES.ADMIN, ROLES.SUPER_ADMIN], context.user?.role);

  const integrationNameCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/integrations/edit/${dataItem.id}`}>{dataItem?.name}</Link>
      </td>
    );
  };

  const integrationStatusCell = (row) => {
    const { dataItem } = row;
    const status = Object.values(INTEGRATION_STATUS).find((s) => s.value === dataItem.status);

    return (
      <td>
        <Link to={`/integrations/edit/${dataItem.id}`}>{status?.label || 'Unknown'}</Link>
      </td>);
  };

  const integrationTypeCell = (row) => {
    const { dataItem } = row;
    const type = Object.values(INTEGRATION_TYPE).find((s) => s.value === dataItem.integrationType);

    return (
      <td>
        <Link to={`/integrations/edit/${dataItem.id}`}>{type?.label || 'Unknown'}</Link>
      </td>);
  };

  const activatedOnCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/integrations/edit/${dataItem.id}`}>
          {dataItem?.activatedOn
            ? <DisplayDate date={dataItem.activatedOn} />
            : '—'}</Link>
      </td>);
  };

  const svilaClientNameCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/integrations/edit/${dataItem.id}`}>{dataItem?.svilaClient.name || '-'}</Link>
      </td>);
  };

  return (
    <WhitePad>
      <TitleComponent
        title="Integrations"
        titleRight="Create"
        onRightHandler={(): void => history.push('/integrations/create')}
        iconRight={createIcon}
        titleLeft="Back"
        onLeftHandler={(): void => history.goBack()}
      />
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn
            field="integrationName"
            title="Integration Name"
            cell={(row) => integrationNameCell(row, stateRef)} />
          <GridColumn
            field="integrationStatus"
            title="Integration Status"
            cell={integrationStatusCell} />
          <GridColumn
            field="integrationType"
            title="Integration Type"
            cell={integrationTypeCell} />
          <GridColumn
            field="activatedOn"
            title="Activated On"
            cell={activatedOnCell} />
          {permissionGranted && (
            <GridColumn
              field="SvilaClientName"
              title="Svila Client Name"
              cell={svilaClientNameCell} />
          )
          }
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
